import { images } from "../constants";

const teamGallery = [
    images.teamGallery_image1,
    images.teamGallery_image2,
    images.teamGallery_image3,
    images.teamGallery_image4,
    images.teamGallery_image5,
    images.teamGallery_image6,
    images.teamGallery_image7,
    images.teamGallery_image8,
];

export default teamGallery;